import { useRef, useState } from "react";
import { UploadCloud, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/** Reusable upload widget. Calls onUploaded({id, path, url, content_type}) with API-relative URL. */
export default function Uploader({ accept = "video/*,image/*", label = "Upload file", onUploaded, testid = "uploader" }) {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const inputRef = useRef(null);

  const onSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true); setProgress(0);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (evt) => { if (evt.total) setProgress(Math.round((evt.loaded/evt.total)*100)); },
      });
      const backend = process.env.REACT_APP_BACKEND_URL;
      const publicUrl = `${backend}${data.url}`;
      onUploaded?.({ ...data, publicUrl });
      toast.success(`Uploaded ${file.name}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
    finally { setLoading(false); e.target.value = ""; }
  };

  return (
    <div>
      <input ref={inputRef} type="file" accept={accept} onChange={onSelect} className="hidden" data-testid={`${testid}-input`} />
      <button type="button" onClick={()=>inputRef.current?.click()} disabled={loading} className="btn-ghost rounded-full px-4 py-2 text-sm flex items-center gap-2 disabled:opacity-60" data-testid={testid}>
        {loading ? <><Loader2 className="w-4 h-4 animate-spin"/>Uploading {progress}%</> : <><UploadCloud className="w-4 h-4"/>{label}</>}
      </button>
    </div>
  );
}
